import { ga4Generic } from "@helper/gtm";
import { delay } from "@helper/urlHelpers";

export const getOneClicks = async (categoryId: number, supplierId: number, regionId: number, supplierName: string): Promise<IOneClick[]> => {
  const response = await fetch('/api/dashboardapi/one-clicks/', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        Categoryid: categoryId, 
        RegionId: regionId, 
        Supplier: supplierName,
        SupplierId: supplierId,
        MaxResults: 5,
    }),
  });

  if (!response.ok) {
      throw new Error('Failed to get one clicks');
  }

  return response.json();
}

export const submitOneClick = async (userName: string, userEmail: string, userPhone: string, weddingDate: Date, categoryId: number, oneClicks: IOneClick[], selectedIds: number[], message: string): Promise<IOneClickResponse[]> => {
  const selectedOneClicks = oneClicks.filter(o => selectedIds.indexOf(o.id) >= 0);
  const data = selectedOneClicks.map(oneClick => {
    return {
      Availability: false,
      Brochure: false,
      CategoryId: categoryId,
      Comment: message,
      Email: userEmail,
      EnquirySource: "OneClick",
      EnquiryType: 1,
      IsOneClick: true,
      Name: userName,
      NominatedDates: "",
      Phone: userPhone,
      Price: false,
      RegionId: oneClick.regionId,
      StateId: oneClick.stateId,
      SupplierEmail: '',
      SupplierId: oneClick.id,
      SupplierName: oneClick.name,
      WeddingDate: weddingDate,
      WeddingLocation: '',
      NumberOfGuests: ''
    };
  });

  const response = await fetch('/api/easydirectoryapi/requestbrochures/', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
      throw new Error('Failed to submit one clicks');
  }

  const oneClickResponses:IOneClickResponse[] = await response.json();

  selectedOneClicks.map(oneClick => {
    const result = oneClickResponses.find(r => r.supplierId === oneClick.id);

    if (result && result.recordGtag) {
      ga4Generic({
        'event': 'generate_lead',
        'supplierName': oneClick.name,
        'ewPageType': 'OneClick',
        'ewInteractionAction': 'enquiry-submitted-oneclick',
        'supplierState': oneClick.state,
        'supplierRegion': oneClick.region,
        'supplierCategory': oneClick.directoryCategory,
      });
    }
  });
  await delay(100);

  return oneClickResponses;
}

export interface IOneClick {
  id: number;
  name: string;
  averageRating: number;
  reviewCount: number;
  thumbnail: string;
  city: string;
  state: string;
  stateId: number;
  region: string;
  directoryCategory: string;
  regionId: number;
}

export interface IOneClickResponse {
  isNewUser: boolean;
  newUserSessionId: string;
  supplierId: number;
  hasError: boolean;
  errorMessage: string;
  recordGtag: boolean;
}